import React from 'react';
import GenericModal from "../GenericModal";
import {Field, FieldArray, Formik} from "formik";
import TextField from "../../Ui/TextField";
import useLocationData from "../../../hooks/DataProvider/useLocationData";
import MenuItem from "@material-ui/core/MenuItem";
import useDonneeTechniqueData from "../../../hooks/DataProvider/useDonneeTechniqueData";
import Divider from "@material-ui/core/Divider";
import FileInput from "../../Ui/FileInput";
import {DO_FICHE_COMMANDE} from "../../../api/Api";
import axios from 'axios';
import * as Yup from 'yup'
import Button from "@material-ui/core/Button";
import {toast} from "react-toastify";


const NewFicheCommandeModal = React.forwardRef((props, ref) => {

        const {children, societe, id} = props
        const [isOpened,setIsOpened] = React.useState(false);
        const [confirmationText,setConfirmationText] = React.useState();
        const [commandeValues,setCommandeValues] = React.useState();
        const formikRef = React.useRef(null);

        const [isDoingCommande,setIsDoingCommande] = React.useState(false)

        console.log('NewFicheCommandeModal.()', ref);

        React.useImperativeHandle(ref,()=>({
                showCommandeModal(){
                    setIsOpened(true)
                }
            })
        );

        async function doCommande(values){

            setIsDoingCommande(true);

            let payload = {};

            for(let prop in values){
                if(values[prop])
                    payload[prop] = values[prop];
            }

            try {

                const response = await axios.post(
                    `${DO_FICHE_COMMANDE}/${id}`,
                    payload
                )

                window.location.reload();

            } catch (e) {
                console.log(e)
            } finally {
                setIsDoingCommande(false)
            }

        }


        function open(){
            setIsOpened(true)
        }

        function onYes(){
            if(formikRef && formikRef.current)
                formikRef.current.submitForm();
        }

        return (
            <div className={'d-inline-block'}>

                <div className={'d-inline-block'} onClick={open}>
                    {children}
                </div>


                <GenericModal
                    isOpen={isOpened}
                    isLoading={isDoingCommande}
                    onNegative={()=>{
                        setIsOpened(false)
                    }}
                    onConfirm={
                        ()=>{
                            doCommande(commandeValues)
                        }
                    }
                    onNegativeConfirm={()=>{setIsOpened(false)}}
                    confirmationButtonText={'Confirmer la commande'}
                    confirmationText={confirmationText}
                    confirmationNegativeButtonText={'Non, prochainement'}
                    onPositive={onYes}
                    positiveText={'Commander'}
                    negativeText={'Annuler'}
                    title={'Commander les travaux'}
                >

                    <Formik
                        innerRef={formikRef}
                        initialValues={{
                            lettre_commande: [],
                            bon_commande: [],
                            ordre_service: [],
                            societe_state: societe
                        }}
                        onSubmit={(values,formikHelpers)=>{

                            const lettreLength = values.lettre_commande.filter(item=>item.value).length;
                            const bonLength = values.bon_commande.filter(item=>item.value).length;
                            const ordreLength = values.ordre_service.filter(item=>item.value).length;

                            if((lettreLength + bonLength + ordreLength) == 0){

                                toast.error('Vous devez joindre au moins un document', {
                                    position: "bottom-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                return;
                            }

                            setConfirmationText('Êtes vous sûr de vouloir confirmer la commande ?');
                            setCommandeValues(values)
                            // doCommande(values)
                        }}
                    >

                        {
                            (formikHelpers) => {
                                return (
                                    <div>

                                        <div className={'row'}>

                                            <div className="col-12 col-md-4 my-3">

                                                <div className={'d-inline-block'}>
                                                                        <span className="font-weight-bolder">
                                                                            Lettre de commande
                                                                    <Button class={'btn btn-secondary ml-2'}
                                                                            onClick={() => {

                                                                                const files = formikHelpers.values.lettre_commande;


                                                                                formikHelpers.setFieldValue('lettre_commande', [
                                                                                    ...files,
                                                                                    {
                                                                                        value: undefined
                                                                                    }
                                                                                ])
                                                                            }}>Ajouter</Button>

                                                                        </span>

                                                    <div className={'small'}>
                                                        (Cliquez sur le bouton "Ajouter" pour sélectionner des pièces jointes supplémentaires)
                                                    </div>

                                                </div>


                                                <div className={'row'}>

                                                    <FieldArray name={'lettre_commande'}
                                                                render={(arrayHelpers) => {
                                                                    return formikHelpers.values.lettre_commande.map(
                                                                        (item, index) => (
                                                                            <div key={index}
                                                                                 className={'col-12'}>

                                                                                <Field

                                                                                    name={`lettre_commande.${index}.value`}
                                                                                    component={FileInput}
                                                                                    variant="outlined"
                                                                                    fullWidth={true}

                                                                                />

                                                                                &nbsp;

                                                                                <div
                                                                                    className={'btn btn-icon btn-light-danger'}
                                                                                    onClick={() => {
                                                                                        arrayHelpers.remove(index)
                                                                                    }}>
                                                                                    <i className={'flaticon2-delete'}></i>
                                                                                </div>

                                                                            </div>
                                                                        )
                                                                    )
                                                                }}
                                                    />

                                                </div>

                                            </div>

                                            <div className="col-12 col-md-4 my-3">

                                                <div className={'d-inline-block'}>
                                                                        <span className="font-weight-bolder">
                                                                            Bon de commande
                                                                    <Button class={'btn btn-secondary ml-2'}
                                                                            onClick={() => {

                                                                                const files = formikHelpers.values.bon_commande;


                                                                                formikHelpers.setFieldValue('bon_commande', [
                                                                                    ...files,
                                                                                    {
                                                                                        value: undefined
                                                                                    }
                                                                                ])
                                                                            }}>Ajouter</Button>

                                                                        </span>

                                                    <div className={'small'}>
                                                        (Cliquez sur le bouton "Ajouter" pour sélectionner des pièces jointes supplémentaires)
                                                    </div>

                                                    <div className={'row'}>

                                                        <FieldArray name={'bon_commande'}
                                                                    render={(arrayHelpers) => {
                                                                        return formikHelpers.values.bon_commande.map(
                                                                            (item, index) => (
                                                                                <div key={index}
                                                                                     className={'col-12'}>

                                                                                    <Field

                                                                                        name={`bon_commande.${index}.value`}
                                                                                        component={FileInput}
                                                                                        variant="outlined"
                                                                                        fullWidth={true}

                                                                                    />

                                                                                    &nbsp;

                                                                                    <div
                                                                                        className={'btn btn-icon btn-light-danger'}
                                                                                        onClick={() => {
                                                                                            arrayHelpers.remove(index)
                                                                                        }}>
                                                                                        <i className={'flaticon2-delete'}></i>
                                                                                    </div>

                                                                                </div>
                                                                            )
                                                                        )
                                                                    }}
                                                        />

                                                    </div>


                                                </div>

                                            </div>

                                            <div className="col-12 col-md-4 my-3">

                                                <div className={'d-inline-block'}>
                                                                        <span className="font-weight-bolder">
                                                                            Ordre de service
                                                                    <Button class={'btn btn-secondary ml-2'}
                                                                            onClick={() => {

                                                                                const files = formikHelpers.values.ordre_service;


                                                                                formikHelpers.setFieldValue('ordre_service', [
                                                                                    ...files,
                                                                                    {
                                                                                        value: undefined
                                                                                    }
                                                                                ])
                                                                            }}>Ajouter</Button>

                                                                        </span>

                                                    <div className={'small'}>
                                                        (Cliquez sur le bouton "Ajouter" pour sélectionner des pièces jointes supplémentaires)
                                                    </div>

                                                </div>

                                                <div className={'row'}>

                                                    <FieldArray name={'ordre_service'}
                                                                render={(arrayHelpers) => {
                                                                    return formikHelpers.values.ordre_service.map(
                                                                        (item, index) => (
                                                                            <div key={index}
                                                                                 className={'col-12'}>

                                                                                <Field

                                                                                    name={`ordre_service.${index}.value`}
                                                                                    component={FileInput}
                                                                                    variant="outlined"
                                                                                    fullWidth={true}

                                                                                />

                                                                                &nbsp;

                                                                                <div
                                                                                    className={'btn btn-icon btn-light-danger'}
                                                                                    onClick={() => {
                                                                                        arrayHelpers.remove(index)
                                                                                    }}>
                                                                                    <i className={'flaticon2-delete'}></i>
                                                                                </div>

                                                                            </div>
                                                                        )
                                                                    )
                                                                }}
                                                    />

                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                )
                            }
                        }

                    </Formik>

                </GenericModal>


            </div>

        )

})

export default NewFicheCommandeModal;